<div *ngIf="authenticationService.currentUser && authenticationService.selectedRole === 'admin'" style="z-index: 100">
	<section class="content-agent" *ngIf="!settings.show" (click)="openChat()">
		<div class="btn-chat">
			<button class="btn btn-primary br-100">
				<div *ngIf="!chatsIaService.loadings.search && !loadings.conversation">
					<i *ngIf="settings.notification" class="bi bi-dot"></i>
					<i class="bi bi-chat-left-fill"></i>
					<div class="text-ai">IA</div>
				</div>
				<div *ngIf="chatsIaService.loadings.search || loadings.conversation" class="dot btn-chat-dot"></div>
			</button>
		</div>
	</section>
	<section class="content-agent" *ngIf="settings.show">
		<!-- HEADER -->
		<div class="content-header p-agent">
			<div class="row">
				<div class="col">Asistente Zeyo IA</div>
				<div class="col-auto">
					<i role="button" (click)="settings.show = false" class="bi bi-x"></i>
				</div>
			</div>
		</div>
		<!-- END HEADER -->

		<!-- SEGMENTS -->

		<div class="row p-0 m-0">
			<div
				(click)="settings.segment = 0"
				role="button"
				class="col text-center content-segment"
				[ngClass]="{ 'bg-primary': settings.segment === 0, 'bg-soft-primary': settings.segment !== 0 }"
			>
				Analiticas
			</div>
			<div
				*ngIf="!environment.production"
				(click)="settings.segment = 1"
				role="button"
				class="col text-center content-segment bg-soft-primary"
				[ngClass]="{ 'bg-primary': settings.segment === 1, 'bg-soft-primary': settings.segment !== 1 }"
			>
				Creación de Procesos
			</div>
		</div>
		<!-- END SEGMENTS -->

		<app-analytics [conversationId]="conversationAnalysisId" *ngIf="settings.segment === 0"></app-analytics>

		<app-process-creation *ngIf="settings.segment === 1"></app-process-creation>
	</section>
</div>
